<template>
    <v-dialog
        v-model="value"
        persistent
        max-width="829px"
        max-height="450px"
        content-class="bible-form-dialog"
    >
        <v-card height="max-content" flat elevation="0">
            <v-card-title class="likert-title">
                <span class="header2">{{ $t('app.likert.title') }}</span>
                <span>
                    <v-btn @click="this.close" class="btn-icon">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </span>
            </v-card-title>
            <v-card-text>
                <v-container class="likert-container">
                    <v-row style="max-height: 60px">
                        <span class="label">{{ $t('app.likert.subtitle') }}</span>
                        <div class="body-text body-text--dark-gray">
                            {{ $t('app.likert.description') }}
                        </div>
                    </v-row>
                    <v-row style="max-height: 30px; margin-bottom: 12px;">
                        <span class="label">{{ $t('app.likert.types') }}</span>
                    </v-row>

                    <v-row style="max-height: 30px; margin-top: 0px">
                        <!-- scale selection radio buttons -->
                        <v-radio-group @change="onScaleSelection" v-model="selectedScale" row
                                       style="margin-top: 0px; padding: 0px">
                            <v-radio v-for="(scale, index) in scales" :key="index" :value="scale.value">
                                <template v-slot:label>
                                    <div class="body-text body-text--dark-gray">{{ scale.label }}</div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-row>
                    <!-- scale types information cards -->
                    <v-row class="likert-card">
                        <v-col v-for="icon in likertIcons" :key="icon.id" cols="12" sm="2" class="likert-description">
                            <v-icon :class="icon.class">{{ icon.icon }}</v-icon>
                            <div class="flex-disp small-body text-center">{{ $t(icon.text) }}</div>
                            <div class="flex-disp small-body body-text--dark-gray text-center">{{ $t(icon.desc) }}</div>
                        </v-col>
                    </v-row>
                    <v-row style="display: flex; justify-content: center; flex-wrap: nowrap">
                        <div v-for="icon in likertIcons" :key="icon.id" cols="12" sm="2" xs="2" :class="icon.color">
                        </div>
                    </v-row>
                    <v-row style="display: flex; justify-content: center; flex-wrap: nowrap">
                        <div v-for="(interval, index) in scaleIntervals" :key="index" class="likert-scale"
                               sm="2" xs="2">
                            {{ interval.value }}
                        </div>
                        <div class="likert-scale"></div>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogMixin from "@/Shared/Dialogs/DialogMixin";
import ReplaceForm from "@/Shared/DathaGatherings/Common/Forms/ReplaceForm";

export default {
    name: "LikertDialog",

    components: {ReplaceForm},

    mixins: [DialogMixin],

    props: {
        dataGathering: {
            type: Object,
            require: true,
        },
    },

    data() {
        return {
            scales: [
                {value: 'scale1-3', label: '1-3'},
                {value: 'scale1-4', label: '1-4'},
                {value: 'scale1-5', label: '1-5'},
                {value: 'scale1-7', label: '1-7'}
            ],
            selectedScale: 'scale1-3',
            scaleIntervals: [{value: '1'}, {value: '1,5'}, {value: '2'}, {value: '2,5'}, {value: '3'}],
            scaleOptions: {
                "scale1-3": [{value: '1'}, {value: '1,5'}, {value: '2'}, {value: '2,5'}, {value: '3'}],
                "scale1-4": [{value: '1'}, {value: '1,75'}, {value: '2,5'}, {value: '3,25'}, {value: '4'}],
                "scale1-5": [{value: '1'}, {value: '2'}, {value: '3'}, {value: '4'}, {value: '5'}],
                "scale1-7": [{value: '1'}, {value: '2,5'}, {value: '4'}, {value: '5,5'}, {value: '7'}]
            },
            likertIcons: [
                {
                    id: 1,
                    icon: 'mdi-emoticon-sad-outline',
                    class: 'likert-icons--nothing',
                    text: 'app.likert.nothing',
                    desc: 'app.likert.nothing_desc',
                    color: 'likert-scale likert-scale--nothing'
                },
                {
                    id: 2,
                    icon: 'mdi-emoticon-dead-outline',
                    class: 'likert-icons--unsatisfying',
                    text: 'app.likert.unsatisfying',
                    desc: 'app.likert.unsatisfying_desc',
                    color: 'likert-scale likert-scale--unsatisfying'
                },
                {
                    id: 3,
                    icon: 'mdi-emoticon-neutral-outline',
                    class: 'likert-icons--somewhat',
                    text: 'app.likert.somewhat',
                    desc: 'app.likert.somewhat_desc',
                    color: 'likert-scale likert-scale--somewhat'
                },
                {
                    id: 4,
                    icon: 'mdi-emoticon-happy-outline',
                    class: 'likert-icons--satisfying',
                    text: 'app.likert.satisfying',
                    desc: 'app.likert.satisfying_desc',
                    color: 'likert-scale likert-scale--satisfying'
                },
                {
                    id: 5,
                    icon: 'mdi-emoticon-outline',
                    class: 'likert-icons--very',
                    text: 'app.likert.very',
                    desc: 'app.likert.very_desc',
                    color: 'likert-scale likert-scale--very'
                },
                {
                    id: 6,
                    icon: 'mdi-emoticon-excited-outline',
                    class: 'likert-icons--fully',
                    text: 'app.likert.fully',
                    desc: 'app.likert.fully_desc',
                    color: 'likert-scale likert-scale--fully'
                }
            ],
        }
    },

    methods: {
        onScaleSelection(value) {
            if (this.scaleOptions[value]) {
                this.scaleIntervals = this.scaleOptions[value]
            }
        }
    },
}
</script>

<style scoped>

</style>
